(() => {
  const setup = () => {
    document.querySelectorAll('.fs-article-shell').forEach(shell => {
      const content = shell.querySelector('.article-template__content');
      const toc = shell.querySelector('[data-fs-toc]');
      if (!content || !toc) return;
      const list = toc.querySelector('ol');
      list.replaceChildren();
      const title = shell.querySelector('.article-template__title');
      const normalize = text => text.toLowerCase().replace(/[^a-z0-9]/g, '');
      const first = content.querySelector('h1,h2');
      if (first && title && normalize(first.textContent) === normalize(title.textContent)) first.hidden = true;
      content.querySelectorAll('h2,h3').forEach((heading, index) => {
        if (heading.hidden || !heading.textContent.trim()) return;
        if (!heading.id) {
          let candidate = `guide-section-${index + 1}`;
          while (document.getElementById(candidate)) candidate += '-section';
          heading.id = candidate;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.hidden = !list.children.length;
      content.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('fs-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'fs-table-scroll';
        table.before(wrapper);
        wrapper.append(table);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
